import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cc7528a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { style: {"position":"fixed","right":"0","top":"100px","z-index":"999"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { style: {"color":"#ffffff","border":"none","font-size":"14px","width":"100px","height":"32px","border-radius":"4px 0px 0px 4px","background-color":"rgb(248, 209, 146)","z-index":"9999"} }, " 在APP打开 ", -1))
const _hoisted_4 = { class: "product-top" }
const _hoisted_5 = {
  class: "custom-indicator",
  id: "agentTitle"
}
const _hoisted_6 = { style: {"color":"#e55c40"} }
const _hoisted_7 = { class: "product-top-b" }
const _hoisted_8 = { class: "product-top-row" }
const _hoisted_9 = { class: "product-middle" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "商品详情", -1))
const _hoisted_12 = { style: {"margin-top":"24px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_wx_open_launch_app = _resolveComponent("wx-open-launch-app")!
  const _component_VideoPlayer = _resolveComponent("VideoPlayer")!
  const _component_SwipeItem = _resolveComponent("SwipeItem")!
  const _component_Swipe = _resolveComponent("Swipe")!
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (!$setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!$setup.isWeiXin)
          ? (_openBlock(), _createBlock(_component_van_image, {
              key: 0,
              width: "24",
              height: "24",
              src: $setup.backIcon,
              onClick: _withModifiers($setup.back, ["stop"]),
              style: {"position":"fixed","z-index":"999","top":"10px","left":"10px"}
            }, null, 8, ["src", "onClick"]))
          : _createCommentVNode("", true),
        (!$setup.isWeiXin)
          ? (_openBlock(), _createBlock(_component_van_image, {
              key: 1,
              width: "24",
              height: "24",
              src: $setup.shareIcon,
              onClick: _withModifiers($setup.share, ["stop"]),
              style: {"position":"fixed","z-index":"999","top":"10px","right":"10px"}
            }, null, 8, ["src", "onClick"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          ($setup.wxPopup)
            ? (_openBlock(), _createBlock(_component_wx_open_launch_app, {
                key: 0,
                id: "launch-btn9",
                appid: "wxf6b9ae5b12f31757",
                extinfo: $setup.sendData,
                onLaunch: $setup.handleLaunchFn,
                onError: $setup.handleErrorFn
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "text/wxtag-template" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }))
                ]),
                _: 1
              }, 8, ["extinfo", "onLaunch", "onError"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Swipe, {
            class: "my-swipe",
            loop: true,
            style: {"height":"375px"},
            "indicator-color": "white",
            onChange: $setup.onChange,
            ref: "swiper"
          }, {
            indicator: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString($setup.current + 1), 1),
                _createTextVNode("/" + _toDisplayString($setup.productDetail.swiperList.imgList.length +
              $setup.productDetail.swiperList.videoList.length), 1)
              ])
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productDetail.swiperList.videoList, (videoItem, index) => {
                return (_openBlock(), _createBlock(_component_SwipeItem, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VideoPlayer, {
                      poster: $setup.videoPhototList[index],
                      "x5-video-player-fullscreen": "true",
                      "x5-playsinline": "",
                      "webkit-playsinline": "",
                      class: "video-player vjs-big-play-centered",
                      src: videoItem,
                      id: 'videoId' + index,
                      crossorigin: "anonymous",
                      playsinline: "",
                      controls: "",
                      autoPlay: "",
                      height: 375,
                      style: {"width":"100%"}
                    }, null, 8, ["poster", "src", "id"])
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productDetail.swiperList.imgList, (image, index) => {
                return (_openBlock(), _createBlock(_component_SwipeItem, {
                  key: index,
                  onClick: ($event: any) => ($setup.preview(index))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_image, {
                      src: image,
                      height: "375",
                      width: "100%"
                    }, null, 8, ["src"])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["onChange"]),
          _createVNode(_component_Skeleton, {
            row: 3,
            loading: $setup.loading
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    style: _normalizeStyle({ color: $setup.type == 'dfxt' ? '#e55c40' : '#B8A480' })
                  }, _toDisplayString($setup.productDetail.point) + _toDisplayString($setup.type == 'dfxt' ? '积分' : '版通积分'), 5),
                  _createElementVNode("div", null, _toDisplayString($setup.productDetail.sale) + "件已兑", 1)
                ]),
                _createElementVNode("div", null, _toDisplayString($setup.productDetail.name), 1)
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "shu",
              style: _normalizeStyle({
            background:
              $setup.type == 'dfxt'
                ? 'linear-gradient(0deg, #f3594f 0%, #ffffff 100%)'
                : 'linear-gradient(0deg, #B8A480 0%, #FFFFFF 100%)'
          })
            }, null, 4),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productDetail.detailInfo, (item, i) => {
              return (_openBlock(), _createBlock(_component_van_image, {
                src: item,
                key: i,
                onClick: ($event: any) => ($setup.preview2(i))
              }, null, 8, ["src", "onClick"]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}